import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} Elite Cleaners. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
